import { render, staticRenderFns } from "./CodingWidget.vue?vue&type=template&id=476e146e&scoped=true&"
import script from "./CodingWidget.vue?vue&type=script&lang=js&"
export * from "./CodingWidget.vue?vue&type=script&lang=js&"
import style0 from "./CodingWidget.vue?vue&type=style&index=0&id=476e146e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476e146e",
  null
  
)

export default component.exports